import { Stack, Typography } from '@mui/material';
import { FormSection } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { CommanderDetails } from './CommanderDetails';
import { Witnesses } from './Witnesses';
import { FormSectionWrapper } from 'Components/FormSectionWrapper';

export const FourthSection = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.CASE_DETAILS);

  return (
    <FormSectionWrapper>
      <FormSection grouped id={dictionary.fourthSectionTitle}>
        <Stack gap='10px'>
          <Typography
            fontSize={isDesktop ? '18px !important' : '16px !important'}
            sx={{ fontWeight: 'bold' }}
          >
            {dictionary.fourthSectionTitle}
          </Typography>
          <Typography>{dictionary.fourthSectionTitleInfo1}</Typography>
          <Typography>{dictionary.fourthSectionTitleInfo2}</Typography>
        </Stack>
        <CommanderDetails />
        <Witnesses />
      </FormSection>
    </FormSectionWrapper>
  );
};
